import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'map',
})
export class MapPipe implements PipeTransform {
  transform(value: any[], key: string): string[] {
    return value ? value.map(e => e[key]) : [];
  }
}
